import client from './client';

export const activityLogsApi = data => client().get('/activity-manager', { params: data });

export const createActivitylogsApi = data => client().post('/activity-manager', data);

export const removeActivitylogsApi = id => client().delete(`/activity-manager/${id}`);

export const editActivitylogsApi = data => client().put(`/activity-manager/${data.id}`, data);
